var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.09981 6.72519L7.61147 4.56212C7.61147 4.56212 8.00037 3.39542 9.29671 3.29169H13.2329C13.3213 3.29169 13.3894 3.36942 13.3753 3.45662C13.3279 3.75029 13.156 4.34925 12.5375 4.52322C12.5375 4.52322 12.7061 5.36585 11.7857 5.85845C11.7857 5.85845 12.019 6.78749 10.9301 7.07485H7.37641C7.19297 7.07485 7.05757 6.90369 7.09981 6.72519Z",
    fill: "#002677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.89988 6.72519L6.38821 4.56212C6.38821 4.56212 5.99931 3.39542 4.70298 3.29169H0.766747C0.678414 3.29169 0.610314 3.36942 0.624414 3.45662C0.671814 3.75029 0.843647 4.34925 1.46215 4.52322C1.46215 4.52322 1.29361 5.36585 2.21401 5.85845C2.21401 5.85845 1.98068 6.78749 3.06961 7.07485H6.62331C6.80671 7.07485 6.94211 6.90369 6.89988 6.72519Z",
    fill: "#002677"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.01717 13.9778C6.8293 13.9778 6.677 13.8256 6.677 13.6377V3.54079C6.677 3.35292 6.82927 3.20062 7.01717 3.20062C7.20504 3.20062 7.35734 3.35289 7.35734 3.54079V13.6377C7.3573 13.8256 7.20504 13.9778 7.01717 13.9778Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.02157 9.90564H5.44067C4.86521 9.90564 4.39697 9.4374 4.39697 8.86194C4.39697 8.28647 4.86521 7.81824 5.44067 7.81824H7.02157C7.20944 7.81824 7.36174 7.9705 7.36174 8.1584C7.36174 8.3463 7.20947 8.49857 7.02157 8.49857H5.44067C5.24031 8.49857 5.07727 8.6616 5.07727 8.86197C5.07727 9.06234 5.24031 9.22537 5.44067 9.22537H7.02157C7.20944 9.22537 7.36174 9.37764 7.36174 9.56554C7.36174 9.75344 7.20947 9.90564 7.02157 9.90564Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.74356 11.3127H7.02156C6.8337 11.3127 6.6814 11.1604 6.6814 10.9725C6.6814 10.7846 6.83366 10.6324 7.02156 10.6324H8.74356C8.94393 10.6324 9.10696 10.4693 9.10696 10.269C9.10696 10.0686 8.94393 9.90555 8.74356 9.90555H7.02156C6.8337 9.90555 6.6814 9.75329 6.6814 9.56539C6.6814 9.37749 6.83366 9.22522 7.02156 9.22522H8.74356C9.31903 9.22522 9.78726 9.69345 9.78726 10.2689C9.78726 10.8445 9.319 11.3127 8.74356 11.3127Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.44714 12.7199H5.44067C4.86521 12.7199 4.39697 12.2517 4.39697 11.6762C4.39697 11.1006 4.86521 10.6324 5.44067 10.6324H7.02157C7.20944 10.6324 7.36174 10.7847 7.36174 10.9726C7.36174 11.1605 7.20947 11.3127 7.02157 11.3127H5.44067C5.24031 11.3127 5.07727 11.4758 5.07727 11.6763C5.07727 11.8766 5.24031 12.0397 5.44067 12.0397H9.44714C9.63501 12.0397 9.78731 12.1919 9.78731 12.3798C9.78731 12.5677 9.63504 12.7199 9.44714 12.7199Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.74356 8.49849H7.02156C6.8337 8.49849 6.6814 8.34622 6.6814 8.15832C6.6814 7.97042 6.83366 7.81816 7.02156 7.81816H8.74356C8.94393 7.81816 9.10696 7.65512 9.10696 7.45462C9.10696 7.25426 8.94393 7.09122 8.74356 7.09122H7.02156C6.8337 7.09122 6.6814 6.93896 6.6814 6.75106C6.6814 6.56316 6.83366 6.41089 7.02156 6.41089H8.74356C9.31903 6.41089 9.78726 6.87912 9.78726 7.45459C9.78726 8.03022 9.319 8.49849 8.74356 8.49849Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.01714 3.66104C6.2773 3.66104 5.67554 3.05928 5.67554 2.31944C5.67554 1.57961 6.2773 0.977844 7.01714 0.977844C7.75697 0.977844 8.35874 1.57961 8.35874 2.31944C8.35874 3.05928 7.75694 3.66104 7.01714 3.66104ZM7.01714 1.52208C6.57747 1.52208 6.21977 1.87978 6.21977 2.31944C6.21977 2.75911 6.57747 3.11681 7.01714 3.11681C7.4568 3.11681 7.8145 2.75911 7.8145 2.31944C7.8145 1.87978 7.4568 1.52208 7.01714 1.52208Z",
    fill: "#FF612B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.01709 3.11683C7.45747 3.11683 7.81446 2.75984 7.81446 2.31946C7.81446 1.87909 7.45747 1.52209 7.01709 1.52209C6.57672 1.52209 6.21973 1.87909 6.21973 2.31946C6.21973 2.75984 6.57672 3.11683 7.01709 3.11683Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipaa);
export default __webpack_public_path__ + "static/media/HIPAA.5e531435825991583ab37b6953d9b4fb.svg";
export { ForwardRef as ReactComponent };